










































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator';
import { stAccountApi, stProjectApi } from '@/services/st-api';
import { UserStore } from '@/store/user-module';
import { notifySuccess } from '@/utlitities/notifications';
import { AccountTimeTrackingSettingsEditModel, PauseMode, ProjectFilter, StSelectListItemGroup, TimeEntryModeEnum } from '@/services/api/nswag/stapiclient_generated';
import StSettingsSeparator from '@/components/basic/Form/StSettingsSeparator.vue';

@Component({
  components: { StSettingsSeparator },
})
export default class AccountSettingsTimeTracking extends Vue {
  @Prop() useProjectTimeTracking!: boolean;
  saveLoading: boolean = false;
  loading: boolean = false;
  loadingOverlay: boolean = false;
  editModel: AccountTimeTrackingSettingsEditModel = AccountTimeTrackingSettingsEditModel.fromJS({});
  logo: string = '';
  projects: StSelectListItemGroup[] = [];

  async mounted() {
    try {
      this.loadingOverlay = true;
      await this.loadData();
    } finally {
      this.loadingOverlay = false;
    }
  }

  get pauseModes() {
    let availableModes = Object.values(PauseMode);

    if (this.editModel.timeEntryMode == TimeEntryModeEnum.Duration) {
      availableModes = [PauseMode.None, PauseMode.Manual];
    }

    if (this.editModel.timeEntryMode == TimeEntryModeEnum.DurationAndTimeFromTo) {
      availableModes = [PauseMode.None, PauseMode.Manual, PauseMode.TimeEntry];
    }

    return availableModes.map((x) => {
      return {
        id: x,
        description: this.getTextFromPauseMode(x),
      };
    });
  }

  get timeEntryModes() {
    return Object.values(TimeEntryModeEnum).map((x) => {
      return {
        id: x,
        description: this.getTextFromTimeEntryMode(x),
      };
    });
  }

  get featureFlagMixedUsers() {
    return UserStore.userSettings.featureFlagMixedUsers;
  }

  get showMixed() {
    return this.$router.currentRoute.query["showMixed"] == "1";
  }

  checkPauseMode() {
    if (this.editModel.timeEntryMode == TimeEntryModeEnum.Duration && (this.editModel.pauseMode == PauseMode.TimeEntry || this.editModel.pauseMode == PauseMode.Auto)) {
      this.editModel.pauseMode = PauseMode.Manual;
      this.editModel.enforcePauseRules = false;
      this.editModel.usePauseRuleWarnings = false;
    } else if (this.editModel.timeEntryMode == TimeEntryModeEnum.DurationAndTimeFromTo && this.editModel.pauseMode == PauseMode.Auto) {
      this.editModel.pauseMode = PauseMode.Manual;
    } else {
      switch (this.editModel.pauseMode) {
        case PauseMode.None:
          this.editModel.usePauseRuleWarnings = false;
          this.editModel.enforcePauseRules = false;
          break;
        case PauseMode.Manual:
          this.editModel.enforcePauseRules = false;
          break;
        case PauseMode.Auto:
          this.editModel.enforcePauseRules = false;
          break;
        case PauseMode.TimeEntry:
          break;
        default:
          break;
      }
    }
  }

  getTextFromPauseMode(mode: PauseMode) {
    switch (mode) {
      case PauseMode.None:
        return this.$t('Pausen nicht erfassen');
      case PauseMode.Manual:
        return this.$t('Pausen manuell erfassen');
      case PauseMode.Auto:
        return this.$t('Zeiten zwischen Zeiteinträgen mit Pause füllen');
      case PauseMode.TimeEntry:
        return this.$t('Pausen am Zeiteintrag erfassen');
    }
  }

  getTextFromTimeEntryMode(mode: TimeEntryModeEnum) {
    switch (mode) {
      case TimeEntryModeEnum.DurationAndTimeFromTo:
        return this.$t('Dauer und Zeit von-bis');
      case TimeEntryModeEnum.Duration:
        return this.$t('Nur Dauer');
      case TimeEntryModeEnum.TimeFromTo:
        return this.$t('Nur Zeit von-bis');
    }
  }

  async loadData() {
    this.editModel = await stAccountApi.getTimeTrackingSettings(UserStore.userSettings.accountId!);
    await this.loadProjects();
  }

  async loadProjects() {
    this.projects = await stProjectApi.getSelectListForTimeTracking();
  }

  async submit() {
    try {
      this.saveLoading = true;
      await stAccountApi.updateTimeTrackingSettings(UserStore.userSettings.accountId!, this.editModel);
      notifySuccess('Gespeichert');
    } finally {
      this.saveLoading = false;
    }
  }
}
